import { useFormContext, Controller, FieldValues, Path } from 'react-hook-form';
import { Text } from '@radix-ui/themes';
import { DigitInput } from '@common/components/DigitInput/DigitInput';
import { DigitInputConfig } from '../../types';
import { FieldWrapper } from '../FieldWrapper';

export const DigitField = <TFormValues extends FieldValues>({
    config,
}: {
    config: DigitInputConfig<TFormValues>;
}) => {
    const { control } = useFormContext<TFormValues>();

    const renderSeparator = (index: number) => {
        const sepChar = config.options.separators?.[index];
        if (sepChar) {
            return (
                <Text
                    size='3'
                    weight='bold'
                    style={{ margin: '0 2px', color: 'var(--gray-11)' }}
                >
                    {sepChar}
                </Text>
            );
        }
        return null;
    };

    return (
        <FieldWrapper config={config}>
            <Controller
                name={config.name as Path<TFormValues>}
                control={control}
                rules={config.validation}
                render={({ field }) => (
                    <DigitInput
                        length={config.options.length}
                        value={field.value || ''}
                        onChange={field.onChange}
                        maxValues={config.options.maxValues}
                        renderSeparator={renderSeparator}
                    />
                )}
            />
        </FieldWrapper>
    );
};
